import { isInMoreThanXMinutes } from "../date.service";

export const isOrderScheduledInMoreThanXMinutes = ( order ) => {
    const {pickupAt} = order ?? {}

    return isInMoreThanXMinutes(pickupAt || new Date(),60)
}
